export const prostoiAvtoState = {
  name: 'prostoiAvtoState',
  url: '/avto/prostoi',
  component: 'prostoiAvto',
  resolve: {},
  data: {
    title: 'Простой автотранспорта',
  },
}
